import React, { useState } from "react";
import Link from "gatsby-link";
import SbEditable from "storyblok-react";
import Logo from "/static/logo_footer.svg";
import resolveLink from "src/utils/resolveLink";
import FooterSection from "./FooterSection";
import { SocialButton } from "@/components/ui/social-button";
import { Accordion, AccordionItem } from "@/components/ui/accordion";

const Footer = ({ settings,type }) => {
  const navData = settings.content.footer_navigation.map((item) => {
    return {
      ...item,
      open: false,
    };
  });

  const [data, setData] = useState(navData);

  const handleClick = (_uid) => {
    setData((data) =>
      data.map((item) => {
        return {
          ...item,
          open: _uid === item._uid ? !item.open : false,
        };
      })
    );
  };

  return (
    <SbEditable content={settings} key={settings._uid}>
      <footer className="bg-darkblue font-display" aria-labelledby="footer">
        <div
          className={`mx-auto max-w-7xl ${
            type === 'orphan' ? 'py-12 px-6 lg:py-16' : 'py-12 px-6'
          }`}
        >
          <div className={`${type === 'orphan' ? '' : 'mb-12'} flex flex-row`}>
            <Link to={resolveLink('/')}>
              <img className="h-11" src={Logo} alt="Cloud Gateway Logo" />
            </Link>
          </div>
          
          <div className="flex flex-col gap-8 lg:flex-row">
            {/* Main content wrapper */}
              {(settings.telephone_number || settings.email) && (
                <div className="mb-8 md:mb-0 lg:w-1/4 md:w-full flex flex-col lg:flex-col md:flex-row  md:justify-between">
                    <div class="flex flex-col gap-5">
                      <div className="text-brightgreen font-display mb-3 lg:mb-7 font-semibold tracking-wider">
                        Contact
                      </div>
                      <div class="flex flex-col">
                      <a
                        href={`tel:${settings.telephone_number}`}
                        className="hover:text-brightgreen py-0.5 text-sm text-white duration-300 tracking-[-0.02em]"
                      >
                        <span className="text-white">T:</span>{' '}
                        {settings.telephone_number}
                      </a>
                      <a
                        href={`mailto:${settings.email}`}
                        className="hover:text-brightgreen py-0.5 text-sm text-white duration-300 tracking-[-0.02em]"
                      >
                        <span className="text-white">E:</span> {settings.email}
                      </a>
                      </div>
                    </div>
                    <div className="mt-6 space-x-3 md:mt-8">
                      <SocialButton className="!p-2" iconSize={5} type="linkedin" url="https://www.linkedin.com/company/cloudgateway/"/>
                      <SocialButton className="!p-2" iconSize={5} type="x" url="https://twitter.com/cloudgatewayltd"/>
                    </div>
                </div>
              )}

            <div className="flex w-full flex-col md:flex-row md:gap-8 lg:gap-16">
              {/* Navigation sections */}
              <div className="grid flex-1 grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4">
                {data.map((item, index) => (
                  <div key={index}>
                    <FooterSection {...item} onClick={handleClick} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Accreditations */}
          <div className="mt-12 flex flex-row md:justify-start justify-center items-center space-x-3 md:mt-16">
            {settings.accreditations.map((img, index) => (
              <img
                key={index}
                src={img?.filename}
                alt={img?.alt}
                className="max-w-[53px]"
              />
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="py-5">
          <div className="mx-auto flex max-w-7xl flex-col px-6 lg:flex-row items-center justify-center md:items-start md:justify-start">
            <p className="mb-1 text-md md:text-xs text-white lg:mb-0">
              © Cloud Gateway {new Date().getFullYear()}. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </SbEditable>
  );
};

export default Footer;
